import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Box,
  makeStyles,
  Slide,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { Link } from 'react-scroll';
import { Trans } from 'react-i18next';

import { ArrowTop } from './ToTop';
import { Text } from '../../shared/components/Text';
import { useWindowScrollYIsGreaterThanEqual } from '../../shared/utils';

const useStyle = makeStyles(theme => ({
  footer: {
    backgroundColor: theme.palette.lightGrey,
    height: 100,
    width: '100%',
    bottom: 0,
  },
  hiddenFooter: {
    display: 'none',
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 30,
    height: '100%',
  },
  linkStyle: {
    color: theme.palette.white,
    paddingLeft: 30,
    textDecoration: 'none',
  },

  arrowContainer: {
    width: '10%',
    top: -25,
    right: 20,
    position: 'absolute',
  },
  text: {
    fontFamily: 'SofiaProBold',
    color: theme.palette.white,
    fontSize: '14px',
    cursor: 'pointer',
    marginRight: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '7px',
    },
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.white,
  },
}));

export const Footer = () => {
  const isGreaterThanEqual = useWindowScrollYIsGreaterThanEqual(150);

  const classes = useStyle();
  return (
    <Slide
      in={!isGreaterThanEqual}
      timeout={500}
      direction="up"
      mountOnEnter
      unmountOnExit
    >
      <AppBar
        position="sticky"
        className={!isGreaterThanEqual ? classes.footer : classes.hiddenFooter}
      >
        <Toolbar className={classes.flexContainer}>
          <Box>
            <Text
              type="text"
              variant="p"
              labelColor="main"
              bold
              uppercase
              className={classes.text}
            >
              <Link to="contacts" smooth>
                <Trans>Contatti</Trans>
              </Link>
            </Text>

            <Text
              type="text"
              variant="p"
              labelColor="main"
              bold
              uppercase
              className={classes.text}
            >
              <a href="/privacy" className={classes.link}>
                PRIVACY
              </a>
            </Text>
          </Box>

          <Box>
            <Text
              type="text"
              variant="p"
              labelColor="main"
              bold
              uppercase
              className={classes.text}
            >
              &2020 BG SERVIZI PROFESSIONALI
            </Text>
          </Box>

          <Box className={classes.arrowContainer}>
            <ArrowTop />
          </Box>
        </Toolbar>
      </AppBar>
    </Slide>
  );
};
